import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { VirtualAccountInfoProps } from "../types";
import { checkExpireText } from "../utils";

// 가상계좌 정보 컴포넌트
// 가상계좌 결제 정보와 관련 안내사항을 표시하는 컴포넌트
export const VirtualAccountInfo = ({ payment, documentProofRequest, virtualAccount, billPayStatus, onCopyAccount }: VirtualAccountInfoProps) => {
  const { t } = useTranslation("contract");
  return (
    <>
      <div className="horizontal-divider" />
      {/* 결제 수단 정보 표시 */}
      <div className="base-section-layout-line">
        <p className="base-section-layout-index text-primary3">{t("detail.paymentMethod")}</p>
        <p className="base-section-layout-value">{t("detail.virtualAccount")}</p>
      </div>

      {/* 증빙서류 타입에 따른 안내 메시지 표시 */}
      <div className="base-section-layout-line">
        <p className="base-section-layout-index text-primary3"></p>
        {documentProofRequest.expenseProofType === "CASHBILL" && (
          <p className="base-section-layout-value text-primary3 font14 font-weight-400 pl80 keep-all">
            {t("detail.cashReceiptAutoIssueNotice")
              .split("\n")
              .map((line, idx) => (
                <Fragment key={idx}>
                  {idx > 0 && <br />}
                  {line}
                </Fragment>
              ))}
          </p>
        )}
        {documentProofRequest.expenseProofType !== "CASHBILL" && (
          <p className="base-section-layout-value text-primary3 font14 font-weight-400 pl80 keep-all">
            {t("detail.taxInvoiceProcessingNotice")
              .split("\n")
              .map((line, idx) => (
                <Fragment key={idx}>
                  {idx > 0 && <br />}
                  {line}
                </Fragment>
              ))}
          </p>
        )}
      </div>

      {/* 결제 성공 전 계좌번호 표시 */}
      {billPayStatus !== "PAYMENT_SUCCESS" && (
        <div className="base-section-layout-line">
          <p className="base-section-layout-index text-primary3">{t("detail.accountNumber")}</p>
          <p className="base-section-layout-value text-underline cursor-pointer" onClick={() => onCopyAccount(virtualAccount?.accountNo)}>
            {virtualAccount?.bankName} {virtualAccount?.accountNo}
          </p>
        </div>
      )}

      {/* 결제 대기 상태일 때 결제일시 표시 */}
      {billPayStatus === "PAYMENT_READY" && (
        <>
          <div className="base-section-layout-line">
            <p className="base-section-layout-index text-primary3">{t("detail.paymentDeadline")}</p>
            <p className="base-section-layout-value">{checkExpireText(virtualAccount)}</p>
          </div>
        </>
      )}
    </>
  );
};
